import {
  Clock01Icon,
  FireIcon,
  GridViewIcon,
  LockIcon,
  StarIcon,
  ThumbsUpIcon,
  Tick02Icon
} from '@hugeicons/react'
import type { ReactNode } from 'react'

import type { FilterChipOption } from '@/shared/ui/Layout/page/FilterChips'

import { MISSION_FILTERS, type MissionFilterId } from '../constants/status'

const MISSION_FILTER_ICONS: Partial<Record<MissionFilterId, ReactNode>> = {
  all: <GridViewIcon size={12} variant="stroke" aria-hidden />,
  /* A estrela é da recência. `recommended` passa a usar polegar — antes as duas
     coisas dividiam o mesmo glifo. */
  new: (
    <StarIcon
      size={12}
      variant="duotone"
      style={{ color: 'var(--color-brand)' }}
      aria-hidden
    />
  ),
  ativas: (
    <FireIcon size={12} variant="stroke" style={{ color: '#ff9800' }} aria-hidden />
  ),
  ending: (
    <Clock01Icon size={12} variant="stroke" style={{ color: '#ff9800' }} aria-hidden />
  ),
  recommended: (
    <ThumbsUpIcon
      size={12}
      variant="stroke"
      style={{ color: 'var(--color-brand)' }}
      aria-hidden
    />
  ),
  success: (
    <Tick02Icon size={12} variant="stroke" style={{ color: '#22c55e' }} aria-hidden />
  ),
  locked: (
    <LockIcon size={12} variant="stroke" style={{ color: '#a1a5b7' }} aria-hidden />
  )
}

export const MISSION_FILTER_OPTIONS: FilterChipOption<MissionFilterId>[] =
  MISSION_FILTERS.map(filter => ({
    ...filter,
    icon: MISSION_FILTER_ICONS[filter.id]
  }))
